/* RUVEE bundle guard. Locks Add to cart and Buy it now until every sample slot has been chosen by the customer. */
(function () {
  var chosen = {};
  var MSG_ID = 'rvm-bundle-msg';

  function slots() {
    return Array.prototype.slice.call(document.querySelectorAll('.ush-variant-option'));
  }
  function keyOf(slot) {
    var t = slot.querySelector('.ush-variant-option-title');
    return t ? t.textContent.trim() : '';
  }
  function pendingSlots() {
    return slots().filter(function (s) { return !chosen[keyOf(s)]; });
  }
  function message() {
    var msg = document.getElementById(MSG_ID);
    if (msg) return msg;
    var anchor = document.querySelector('[data-ai-cart]');
    if (!anchor) return null;
    msg = document.createElement('p');
    msg.id = MSG_ID;
    msg.className = 'rvm-bundle-msg';
    msg.setAttribute('role', 'status');
    msg.hidden = true;
    anchor.parentNode.insertBefore(msg, anchor);
    return msg;
  }
  function paint() {
    var all = slots();
    if (!all.length) return;
    var pending = pendingSlots();
    all.forEach(function (s) {
      s.classList.toggle('rvm-slot-pending', !chosen[keyOf(s)]);
    });
    var locked = pending.length > 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ai-add],[data-ai-buy-now]'), function (b) {
      b.setAttribute('aria-disabled', locked ? 'true' : 'false');
      b.classList.toggle('rvm-guard-locked', locked);
    });
    var msg = message();
    if (msg) {
      msg.textContent = locked ? 'Choose a fragrance for every slot to continue. ' + pending.length + ' left.' : '';
      msg.hidden = !locked;
    }
  }
  function nudge() {
    var first = pendingSlots()[0];
    if (first && first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
    paint();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('.ush-variant-option .zy-select-item');
    if (item) {
      var slot = item.closest('.ush-variant-option');
      chosen[keyOf(slot)] = true;
      setTimeout(paint, 0);
      setTimeout(paint, 300);
      return;
    }
    var btn = t.closest('[data-ai-add],[data-ai-buy-now]');
    if (btn && pendingSlots().length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-ai-cart]') && pendingSlots().length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
    }
  }, true);

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(paint, 80);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', paint);
  window.addEventListener('load', paint);
  paint();
})();
